<div class="row">
  <div class="col-12 page-title">
    <div class="title-wrapper">
      <h1>Dashboards</h1>
    </div>
  </div>
</div>

<div class="cards-container">

  <div class="card cursor-pointer" [routerLink]="['/dashboard/eval']">
    <i class="card-icon app-icon-board color-topaz"></i>
    <span class="card-title">Captações</span>
  </div>

  <div class="card cursor-pointer" [routerLink]="['/dashboard/lead']">
    <i class="card-icon app-icon-layers color-topaz"></i>
    <span class="card-title">Leads</span>
  </div>

</div>